var _path, _rect, _rect2, _path2, _path3, _mask, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallPharmacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41663 3.5H20.5833V21.5H1.41663V3.5Z",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.83337,
    y: 10.5835,
    width: 6.33333,
    height: 10.9167,
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.83337,
    y: 3.6665,
    width: 18.3333,
    height: 2.75,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 6.5H20.5",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1C0.5 0.723858 0.723858 0.5 1 0.5H21C21.2761 0.5 21.5 0.723858 21.5 1V2.66667C21.5 2.94281 21.2761 3.16667 21 3.16667H1C0.723858 3.16667 0.5 2.94281 0.5 2.66667V1Z",
    stroke: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_1124_11726",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5C0 21.2239 0.223858 21 0.5 21H21.5C21.7761 21 22 21.2239 22 21.5C22 21.7761 21.7761 22 21.5 22H0.5C0.223857 22 0 21.7761 0 21.5Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.5C0 21.2239 0.223858 21 0.5 21H21.5C21.7761 21 22 21.2239 22 21.5C22 21.7761 21.7761 22 21.5 22H0.5C0.223857 22 0 21.7761 0 21.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 22H21.5V20H0.5V22ZM21.5 21H0.5V23H21.5V21ZM0.5 21C0.776143 21 1 21.2239 1 21.5H-1C-1 22.3284 -0.328429 23 0.5 23V21ZM21 21.5C21 21.2239 21.2239 21 21.5 21V23C22.3284 23 23 22.3284 23 21.5H21ZM21.5 22C21.2239 22 21 21.7761 21 21.5H23C23 20.6716 22.3284 20 21.5 20V22ZM0.5 20C-0.328427 20 -1 20.6716 -1 21.5H1C1 21.7761 0.776142 22 0.5 22V20Z",
    fill: "black",
    mask: "url(#path-6-inside-1_1124_11726)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPharmacy);
export default __webpack_public_path__ + "static/media/small-pharmacy.2e55ce932b5b4c0489d2e793c9fc2a73.svg";
export { ForwardRef as ReactComponent };